import React from 'react';
import { Modal, Typography, Button } from 'antd';
import ButtonRow from 'components/common/ButtonRow';

const EntityActivationModal = props => {
  return (
    <Modal title={props.action + ' Entity'} visible={props.isModalVisible} onCancel={props.closeModal} footer={null}>
      <Typography.Paragraph strong>
        Are you sure you want to {props.action.toLowerCase()} this entity?
      </Typography.Paragraph>
      <Typography.Paragraph>{props.entity.name}</Typography.Paragraph>
      <ButtonRow style={{ marginTop: '2em' }}>
        <Button type="primary" onClick={props.onSubmit}>
          {props.action}
        </Button>
        <Button onClick={props.closeModal}>Cancel</Button>
      </ButtonRow>
    </Modal>
  );
};

export default EntityActivationModal;
